<template>
  <b-container fluid>
    <b-card
      header="사이트맵"
      style="max-width: 60rem; margin: auto; margin-top: 3vh;"
      class="mb-2"
      align="left"
    >
      <b-form-group id="">
        <b-row>
          <div :key="link.name" v-for="link in links">
            <b-col cols="12">
              <b-card
                :title="link.name"
                :img-src="link.image"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 17.5rem; height: 25rem;"
                class="mb-2"
              >
                <b-card-text>
                  {{ link.text }}
                </b-card-text>

                <b-button :to="link.route" variant="primary">이동</b-button>
                <Spinner />
              </b-card>
            </b-col>
          </div>
        </b-row>
      </b-form-group>
    </b-card>
    <!-- <Modal v-on:closeModal="closeModal"></Modal> -->
  </b-container>
</template>

<script>
import Spinner from "../components/Spinner";
import { init, conversion, setSnackBarInfo } from "../js/common_function";

export default {
  components: {
    Spinner,
  },
  data() {
    return {
      links: [
        {
          name: "HOME",
          text:
            "메인 화면 입니다. 각 카테고리 별 최근 작성글들을 볼 수 있습니다.",
          route: "/",
          image: "",
        },
        {
          name: "경제",
          text:
            "경제 및 사회관련 이슈를 주관적인 입장에서 정리해놓은 게시판입니다.",
          route: "/Finance",
          image: "",
        },
        {
          name: "부동산",
          text: "부동산을 재테크 관점에서 정리해놓은 게시판입니다.",
          route: "/RealEstate",
          image: "",
        },
        {
          name: "IT",
          text:
            "IT 및 신기술을 정리해놓은 게시판입니다. 업무상 필요한 정보도 있습니다.",
          route: "/IT",
          image: "",
        },
        {
          name: "언어학습",
          text:
            "2022년 9월 YBM 어학원에서 배운 표현들을 정리해두었습니다. 현재 EBS에서 방송되는 입트영과 귀트영 표현도 정리하였습니다.",
          route: "/English",
          image: "",
        },
        {
          name: "포럼",
          text:
            "각종 정보들에 대한 메모들을 정리해놓은 곳 입니다. 개인정보 때문에 회원제로 운영됩니다.",
          route: "/Forum",
          image: "",
        },
        {
          name: "오늘의 이슈",
          text:
            "매일매일 3개 신문사, 2개 상위 커뮤니티 내 헤드라인을 크롤링하여 상위 30개 단어를 추려냅니다.",
          route: "/Issue",
          image: "",
        },
        {
          name: "유머",
          text: "재미있는 글들을 모아두어 즐겁게 하기 위한 게시판입니다.",
          route: "/Humor",
          image: "",
        },
        {
          name: "여행일기",
          text:
            "여행기를 적어둔 게시판입니다. 본 홈페이지의 메인 게시판이라 할 수 있습니다.",
          route: "/Travel",
          image: "",
        },
        {
          name: "감상문",
          text:
            "책, 영화, 미디어 등 작품을 보고 느낀점에 대해 정리해둔 게시판입니다.",
          route: "/Comment",
          image: "",
        },
        {
          name: "운동일지",
          text: "운동 후, 기록을 정리해둔 게시판입니다.",
          route: "/Exercise",
          image: "",
        },
        {
          name: "봉구일지",
          text:
            "2022년 3월 6일생 우리 아비시니안 고양이 봉구를 소개해놓은 게시판입니다. 봉구의 일상생활을 볼 수 있습니다.",
          route: "/BongGu",
          image: "",
        },
      ],
    };
  },
  computed: {},

  methods: {
    callAllListApi() {
      this.$store.commit("START_SPINNER");
      this.results = [];

      this.$axios({
        url: this.$config.baseHomeLogURL + "/siteMapGetImg",
        method: "get",
        data: {},
        headers: {
          "token-key": localStorage.getItem("token-key"),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            const compare = this.links;
            response.data.map(function (value, key) {
              compare.map(function (value2, key2) {
                if (value2.name === value.title) {
                  value2.image = value.contentsHTML;
                }
              });
            });
            this.links = compare;
            this.$store.commit("END_SPINNER");
          } else {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한이 없습니다.")
            );
            this.$store.commit("END_SPINNER");
          }
        })
        .catch((error) => {
          this.errors.push(error);
          console.log(error);
        });
    },
  },
  async mounted() {
    this.$parent.$parent.$children.map(function (value, key) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = false;
      }
    });
    const path = this.$route.fullPath;
    // document.body.setAttribute("oncontextmenu", "return false");
    // document.body.setAttribute("onselectstart", "return false");
    // document.body.setAttribute("ondragstart", "return false");
    init(path).then((res) => {
      this.callAllListApi();

      this.$router.afterEach((to, from) => {
        if (
          from.name.substring(from.name.length - 6, from.name.length) ===
          "Detail"
        ) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: Math.abs(from.params.scrollY) });
          }, 2000);
        }
      });
    });
  },
  created() {
    document.addEventListener("scroll", this.listenScroll);
  },
  destroyed() {
    // remember to remove the listener when destroy the components
    document.removeEventListener("scroll", this.listenScroll);
  },
};
</script>
<style lan="scss">
.card-img-top {
  height: 10rem;
}
.v-application a {
  color: white;
}
</style>
